const EN = {
    title: 'Summaries',
    table: {
        title: 'Summaries List',
        columns: {
            id: 'ID',
            period: 'Period',
            pdf: 'PDF',
            date: 'Emission date',
            document: 'INE',
            lastFour: 'Last 4'
        },
    }
};

export default EN;
